/**
 * Local, inspected Commons stock photos (see public/media/stock/LICENSE.txt).
 * Used as homepage fallbacks so we never hotlink Unsplash or the broken
 * spot-images library (cat statue, AI portraits, East-Asian towers).
 */
export const STOCK = {
    pvHero: '/media/stock/pv/rooftop-efh-vilshofen.jpg',
    pvRoof: '/media/stock/pv/rooftop-berlin.jpg',
    pvBrick: '/media/stock/pv/rooftop-north-brick.jpg',
    pvInverter: '/media/stock/pv/inverter-meter-cabinet.jpg',
    wpOutdoor: '/media/stock/wp/outdoor-weimar.jpg',
    wpHeizraum: '/media/stock/wp/heizraum-stiebel.jpg',
    hybridReihenhaus: '/media/stock/hybrid/reihenhaus-allermoehe.jpg',
    utilityPark: '/media/stock/utility/solarpark-woerrstadt.jpg',
    utilityPark2: '/media/stock/utility/solarpark-borna.jpg',
    bremenStreet: '/media/stock/bremen/reihenhaeuser-neustadt.jpg',
    calcMeter: '/media/stock/calc/wechselstromzaehler.jpg',
};

/** Drop the old library / Unsplash hotlinks; keep an explicit custom upload. */
export function preferStock(url, fallback) {
    if (!url) return fallback;
    const s = String(url);
    if (
        s.includes('images.unsplash.com')
        || s.includes('/media/spot-images/')
        || s.includes('/images/hero-main')
    ) {
        return fallback;
    }
    return s;
}

function hostName(domain) {
    return String(domain?.name || domain?.request_host || '')
        .replace(/^www\./i, '')
        .toLowerCase();
}

export function stockImages(domain, service) {
    const host = hostName(domain);
    const isWP = service === 'wp';

    if (host.includes('bremen')) {
        return {
            hero: STOCK.bremenStreet,
            feature: STOCK.hybridReihenhaus,
            process: STOCK.wpOutdoor,
            extra: STOCK.pvBrick,
        };
    }
    if (host.includes('millennium')) {
        return {
            hero: STOCK.utilityPark,
            feature: STOCK.utilityPark2,
            process: STOCK.pvInverter,
            extra: STOCK.pvHero,
        };
    }
    if (host.includes('kostenrechner') || host.includes('waermepreis')) {
        return {
            hero: isWP ? STOCK.wpOutdoor : STOCK.pvHero,
            feature: STOCK.calcMeter,
            process: STOCK.pvInverter,
            extra: isWP ? STOCK.wpHeizraum : STOCK.pvRoof,
        };
    }
    if (
        host.includes('autark')
        || host.includes('pvheizung')
        || host.includes('heizungzukunft')
        || host.includes('heizungssuche')
    ) {
        return {
            hero: STOCK.hybridReihenhaus,
            feature: STOCK.wpOutdoor,
            process: STOCK.pvInverter,
            extra: STOCK.wpHeizraum,
        };
    }
    if (isWP) {
        return {
            hero: STOCK.wpOutdoor,
            feature: STOCK.wpHeizraum,
            process: STOCK.wpOutdoor,
            extra: STOCK.calcMeter,
        };
    }
    return {
        hero: STOCK.pvHero,
        feature: STOCK.pvRoof,
        process: STOCK.pvInverter,
        extra: STOCK.pvBrick,
    };
}
